import React, { useEffect, useState } from 'react'

import "common/css/master.css";


const SubjectAllocationTable = (props) => {
    const { lstSubjectAllocation, subjectAllocationId, setSubjectAllocationId, editSubjectAllocation, deleteSubjectAllocation, lstSubId, handleSelectChange } = props;

    const [lstSubjectAllocationFiltered, setLstSubjectAllocationFiltered] = useState([]);
    const [selSubjectAllocationId, setSelSubjectAllocationId] = useState(0);
    const [totalPeriods, setTotalPeriods] = useState(0);
    const [lstSubjectId, setLstSubjectId] = useState([]);

    useEffect(() => {
        // console.log("useEffect in SubjectAllocationTable component called, lstSubjectAllocation", lstSubjectAllocation);
        setLstSubjectAllocationFiltered(lstSubjectAllocation);
        calculateTotalPeriods(lstSubjectAllocation);
        setLstSubjectId([]);
    }, [lstSubjectAllocation]);

    useEffect(() => {
        // console.log("useEffect in SubjectAllocationTable component called subjectAllocationId", subjectAllocationId);
        setSelSubjectAllocationId(subjectAllocationId);
    }, [subjectAllocationId]);

    useEffect(() => {
        setLstSubjectId(lstSubId);
    }, [lstSubId]);

    const colgrp = <colgroup>
        <col width="80"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="35"></col>
        <col width="20"></col>
        <col width="60"></col>
        <col width="40"></col>
    </colgroup>

    const calculateTotalPeriods = (pLstSubjectAllocation) => {
        // console.log("Method called: calculateTotalPeriods");
        // console.log("Parameters passed:", { pLstSubjectAllocation });
        
        const total = pLstSubjectAllocation.reduce((sum, allocation) => {
            return sum + (allocation.totalPeriod || 0);
        }, 0);

        // console.log("Total periods calculated:", total);
        setTotalPeriods(total);
    };

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                Subject
                            </th>
                            <th >
                                Total Periods
                            </th>
                            <th >
                                Common Teacher
                            </th>
                            <th >
                                Shared Slot
                            </th>
                            <th >
                                Select
                            </th>
                            <th >
                                Facility
                            </th>
                            <th >
                                Action
                            </th>
                        </tr>
                    </thead>
                </table>
                <div
                    className="tableDiv"
                    style={{ height: "60vh", pointerEvents: "auto", zIndex: 1, position: "relative" }}
                >
                    <table className="tableLayout" style={{ position: "relative" }}>
                        {colgrp}
                        <tbody id="diaryMonthlySubjectAllocationTable">
                            {lstSubjectAllocationFiltered &&
                                lstSubjectAllocationFiltered.map((subjectAllocation, i) => (
                                    <tr
                                        key={subjectAllocation.subjectAllocationId}
                                        onClick={() => setSubjectAllocationId(subjectAllocation.subjectAllocationId)}
                                        className={subjectAllocation.subId === selSubjectAllocationId ? "selected" : ''}
                                    >
                                        <td className="text-left">{subjectAllocation.sub}</td>
                                        <td className="text-center">{subjectAllocation.totalPeriod}</td>
                                        <td className="text-center">{subjectAllocation.flgCommonTch ? "Yes" : "No"}</td>
                                        <td className="text-center">{subjectAllocation.sharedSlotNo ? subjectAllocation.sharedSlotNo : "-"}</td>
                                        <td className="text-center">
                                            <input type="checkbox"
                                                className="form-check-input"
                                                checked={!!lstSubjectId && lstSubjectId.includes(subjectAllocation.subId)}
                                                onChange={() => handleSelectChange(subjectAllocation.subId)}
                                                onClick={(e) => { e.stopPropagation(); }}
                                            />
                                        </td>
                                        <td className="text-center">{subjectAllocation.facility ? subjectAllocation.facility : "-"}</td>
                                        <td className="text-center">
                                            <span
                                                onClick={() => editSubjectAllocation(subjectAllocation)}
                                                title="Edit Subject Allocation Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Edit
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div  style={{paddingRight:"17px"}}>
                    <table className="tableLayout" style={{ width: "100%" }}>
                        <tfoot>
                            <tr>
                                <td width="80">Total Periods Allocated</td>
                                <td width="35">{totalPeriods}</td>
                                <td width="190"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

            </div>
        </div>
    );
}

export default SubjectAllocationTable;